import { Button } from '@gerdau/hefesto/Button';
import { Icon } from '@gerdau/hefesto/Icon';
import { Title } from '@gerdau/hefesto/Title';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { formatTaggingString } from '../../../../../utils/formatStrings';
import { Container, ErrorCircleIcon, TitleContainer } from './styles';

interface IFailSuccess {
  onTryAgainClick(): void;
}

const Fail: React.FC<IFailSuccess> = ({ onTryAgainClick }) => {
  const shoppingCartState = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );
  const taggingInfoPreviousScreen = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:ErroEnvio`,
        page: window.location.pathname,
        orderCliente: formatTaggingString(shoppingCartState.customerOrder),
        event: 'page_view'
      })
    );
    dispatch(
      sendTagging({
        page: window.location.pathname,
        screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:ErroEnvio`,
        itemName: 'error:falhaEnviarPedido',
        itemDescription: `comprar_acosLongos_${taggingInfoPreviousScreen.itemDescription}_enviarParaAnalise_erroEnvio_falhaEnviarPedido`,
        orderCliente: formatTaggingString(shoppingCartState.customerOrder),
        nonInteraction: true,
        event: 'error'
      })
    );
  }, [dispatch]);

  const handleOnTryAgainClick = () => {
    dispatch(
      sendTagging({
        page: window.location.pathname,
        screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:ErroEnvio`,
        itemName: 'button:tentarNovamente',
        itemDescription: `comprar_acosLongos_${taggingInfoPreviousScreen.itemDescription}_enviarParaAnalise_erroEnvio_tentarNovamente`,
        orderCliente: formatTaggingString(shoppingCartState.customerOrder),
        event: 'click'
      })
    );
    onTryAgainClick();
  };

  return (
    <Container>
      <ErrorCircleIcon>
        <Icon option="CancelCircle" variant="danger"></Icon>
      </ErrorCircleIcon>

      <TitleContainer>
        <Title level={2}>Falha no envio do pedido!</Title>
      </TitleContainer>

      <span className="message">
        Você pode tentar enviar seu pedido novamente em um <br />
        minuto clicando no botão abaixo. Se o problema persistir,
        <br />
        entre em contato com seu vendedor
      </span>

      <div className="actions">
        <Button
          name="try-again"
          variant="primary"
          onClick={handleOnTryAgainClick}
        >
          Tentar novamente
        </Button>
      </div>
    </Container>
  );
};

export default Fail;
